import { render } from "./TopCard.vue?vue&type=template&id=11c2bdf6&scoped=true&ts=true"
import script from "./TopCard.vue?vue&type=script&lang=ts"
export * from "./TopCard.vue?vue&type=script&lang=ts"

import "./TopCard.vue?vue&type=style&index=0&id=11c2bdf6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c2bdf6"]])

export default __exports__